// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Llama.ExpenseReceipt')
class Llama__ExpenseReceipt {
    @jsonProperty(() => Llama__ExpenseReceipt.Id)
    id: Llama__ExpenseReceipt.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "string" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "filename", "mimeType", "receiptData", "receiptDataId", "expense", "expenseId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "filename", "mimeType", "receiptData", "receiptDataId", "expense", "expenseId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "filename", "mimeType", "receiptData", "receiptDataId", "expense", "expenseId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "filename": "string", "mimeType": "string", "receiptData": "System.BinaryData", "receiptDataId": "System.BinaryData.Id", "expense": "Llama.Expense", "expenseId": "Llama.Expense.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "string" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ expense: () => Llama.Expense } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ receiptData: () => System.BinaryData } as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = String;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θfilename? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θmimeType? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θreceiptData? = Signals.proxySignalDeferred<System.BinaryData>(() => undefined);
    private readonly θreceiptDataId? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θexpense? = Signals.proxySignalDeferred<Llama.Expense>(() => undefined);
    private readonly θexpenseId? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θcreatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θupdatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θdeletedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θversionNumber? = Signals.proxySignalDeferred<number>(() => undefined);

    static get __type(): 'Llama.ExpenseReceipt' {
        return 'Llama.ExpenseReceipt'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Llama.ExpenseReceipt' {
        return 'Llama.ExpenseReceipt'
    }

    static get __baseType(): 'Llama.ExpenseReceipt' {
        return 'Llama.ExpenseReceipt'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Llama.ExpenseReceipt' {
        return 'Llama.ExpenseReceipt'
    }

    get [BoInfoSymbol]() {
        return Llama__ExpenseReceipt[BoInfoSymbol]
    }

    get filename(): string {
        return this.θfilename?.()
    }

    set filename(filename) {
        this.θfilename.set(LowgileDataUtil.coerceDataType(filename, 'string', false, true))
    }

    get mimeType(): string {
        return this.θmimeType?.()
    }

    set mimeType(mimeType) {
        this.θmimeType.set(LowgileDataUtil.coerceDataType(mimeType, 'string', false, true))
    }

    get receiptData(): System.BinaryData {
        return this.θreceiptData?.()
    }

    set receiptData(receiptData) {
        this.θreceiptData.set(LowgileDataUtil.coerceDataType(receiptData, System.BinaryData, false, true))
        if (receiptData) {
            this.θreceiptDataId.set(receiptData.id)
        } else if (receiptData === null && receiptData) {
            this.θreceiptDataId.set(null)
        }
    }

    get receiptDataId(): System.BinaryData.Id {
        return this.θreceiptDataId?.()
    }

    set receiptDataId(receiptDataId) {
        if (receiptDataId === null) this.θreceiptData.set(null)
        if (this.receiptData?.id && receiptDataId != this.receiptData.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θreceiptDataId.set(LowgileDataUtil.coerceDataType(receiptDataId, 'string', false, true))
    }

    get expense(): Llama.Expense {
        return this.θexpense?.()
    }

    set expense(expense) {
        this.θexpense.set(LowgileDataUtil.coerceDataType(expense, Llama.Expense, false, true))
        if (expense) {
            this.θexpenseId.set(expense.id)
        } else if (expense === null && expense) {
            this.θexpenseId.set(null)
        }
    }

    get expenseId(): Llama.Expense.Id {
        return this.θexpenseId?.()
    }

    set expenseId(expenseId) {
        if (expenseId === null) this.θexpense.set(null)
        if (this.expense?.id && expenseId != this.expense.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θexpenseId.set(LowgileDataUtil.coerceDataType(expenseId, 'string', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Llama__ExpenseReceipt>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        LowgileDataUtil.assignCommonProperties(this, init)
        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Llama__ExpenseReceipt()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Llama__ExpenseReceipt>, restrictToClass?: Class<Partial<Llama__ExpenseReceipt>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            filename: z.string(),
            mimeType: z.string(),
            get receiptData() { return System.BinaryData.$getSchema() },
            receiptDataId: System.BinaryData.$getSchema().shape.id,
            get expense() { return Llama.Expense.$getSchema() },
            expenseId: Llama.Expense.$getSchema().shape.id,
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Llama__ExpenseReceipt.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('filename', 'mimeType', 'receiptData', 'receiptDataId', 'expense', 'expenseId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Llama__ExpenseReceipt {
        return equal(this, other)
    }
}

namespace Llama__ExpenseReceipt { }

export import ExpenseReceipt = Llama__ExpenseReceipt
setTimeout(() => {
    jsonProperty(() => String)(Llama__ExpenseReceipt.prototype, 'filename')
    jsonProperty(() => String)(Llama__ExpenseReceipt.prototype, 'mimeType')
    jsonProperty(() => System.BinaryData)(Llama__ExpenseReceipt.prototype, 'receiptData')
    jsonProperty(() => String)(Llama__ExpenseReceipt.prototype, 'receiptDataId')
    jsonProperty(() => Llama.Expense)(Llama__ExpenseReceipt.prototype, 'expense')
    jsonProperty(() => String)(Llama__ExpenseReceipt.prototype, 'expenseId')
    jsonProperty(() => Date)(Llama__ExpenseReceipt.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Llama__ExpenseReceipt.prototype, 'createdBy')
    jsonProperty(() => Date)(Llama__ExpenseReceipt.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__ExpenseReceipt.prototype, 'updatedBy')
    jsonProperty(() => Date)(Llama__ExpenseReceipt.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__ExpenseReceipt.prototype, 'deletedBy')
    jsonProperty(() => Number)(Llama__ExpenseReceipt.prototype, 'versionNumber')
})

export const ExpenseReceiptθId = String;

export type ExpenseReceiptθId = string;

namespace Llama__ExpenseReceipt {
    export type Id = NominalType<string, 'Llama.ExpenseReceipt'>

}
